import { Content } from 'antd/es/layout/layout'
import Breadcrumbs from 'components/Breadcrumbs'
import DashboardTile from 'components/Dashboard/DashboardTile'
import QuickLinks from 'components/Dashboard/QuickLinks'
import GameEmbedInfo from 'components/Embeds/GameEmbedInfo'
import OrgNavigate from 'components/System/OrgNavigate'
import useFetchData from 'hooks/useFetchData'
import useFetchEntities from 'hooks/useFetchEntities'
import { useMemo } from 'react'
import useLoginStore from 'store/loginStore'
import icons from 'utils/icons'

const PlayerHome = () => {
  const user = useLoginStore(s => s.user);

  if (user?.Players?.[0]?.status == 'INVITED') {
    return <OrgNavigate to="/player_profile" />
  }

  return <OrgNavigate to="/dashboard_player" />
}

export default PlayerHome 